import { render } from "./SerenePrivacyPolicyES.vue?vue&type=template&id=451640aa"
import script from "./SerenePrivacyPolicyES.vue?vue&type=script&lang=js"
export * from "./SerenePrivacyPolicyES.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__